import { render, staticRenderFns } from "./StudentAttachmentList.vue?vue&type=template&id=0bca9d4a&"
import script from "./StudentAttachmentList.vue?vue&type=script&lang=ts&"
export * from "./StudentAttachmentList.vue?vue&type=script&lang=ts&"
import style0 from "./StudentAttachmentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports